<template>
  <v-footer
    height="auto"
    color="grey darken-2"
    fixed
  >
    <v-layout justify-center row wrap>
      <v-btn
        v-for="link in links"
        :key="link.name"
        color="white"
        flat
        round
        @click="goto(link)"
      >
        {{ link.name }}
      </v-btn>
      <v-flex
        grey
        darken-3
        py-1
        text-xs-center
        white--text
        xs12
      >
        &copy;2019 <strong>Maroondah Cycle Training Club Inc.</strong> Incorporation Registered No. A0001470C
      </v-flex>
    </v-layout>
  </v-footer>
</template>
<script>
export default {
  name: 'siteFooter',
  props: ['isAdmin'],
  data: () => ({
    options: {
      duration: 800,
      offset: 100,
      easing: 'easeInOutCubic'
    },
    links: [
      {
        name: 'Home',
        path: '/',
        scroll: 1
      },
      {
        name: 'About Us',
        path: '/',
        scroll: '#about'
      },
      {
        name: 'Services',
        path: '/',
        scroll: '#services'
      },
      {
        name: 'Contact Us',
        path: '/',
        scroll: '#contactus'
      },
      {
        name: 'Sponsors',
        path: '/',
        scroll: '#sponsors'
      }
    ]
  }),
  methods: {
    goto: function (link) {
      if (this.$router.history.current.path === link.path) this.$vuetify.goTo(link.scroll, this.options)
      else this.$router.push(link.path)
    }
  }
}
</script>
